// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
// Ngrx reducers
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { IndicesByAssetClassPageComponent } from './components/indices-by-asset-class-page/indices-by-asset-class-page.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [IndicesByAssetClassPageComponent, TopBarNavComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        NavigationModule,
        // We need a root store (even if it's empty) because the autocompleter in the top bar nav uses NgRx
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        BaseAutocompleteModule,
        LoadingSymbolModule] });
